module.exports = __webpack_public_path__ + "img/fran-pro.c8334b1d.jpg";